<template>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
          <v-card-title class="primary white--text title">
              Parameter
          </v-card-title>
          <v-card-text>
              <facility-selector v-model="activeItem.facility_name"></facility-selector>
              <v-text-field label="Parameter Name" autofocus v-model="activeItem.parameter_name"></v-text-field>
              <v-text-field label="Parameter Value" autofocus v-model="activeItem.parameter_value"></v-text-field>
              <v-text-field label="Parameter Value Str" autofocus v-model="activeItem.parameter_value_str"></v-text-field>
              <v-text-field label="Parameter Description" autofocus v-model="activeItem.parameter_description"></v-text-field>
          </v-card-text>

          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="primary" @click="addRecord(true)" :disabled="!$can('update', 'Parameter')">Save</v-btn>
              <v-btn @click="initializeVar(true)">Cancel</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  import FacilitySelector from '../FacilitySelector'
  import {putParameter} from '../../helper'

  export default {
    components: { FacilitySelector },
    props: {
      value: {type:Boolean, default: true},
      item: {type: Object, default: null}
    },
    watch: {
      item (item) {
        this.initializeVar()
        if (item){
          this.activeItem = this.item
        }
      },
      value () {
        if (!this.activeItem.parameter_id) {
          this.initializeVar()
        }
        if (this.dialog !=this.value){
          this.dialog=this.value
        }
      },
      dialog () {
        this.$emit('input', this.dialog)
      }
    },
    data () {
      return {
        dialog: false,
        activeItem: {
          parameter_id: null,
          facility_name: '',
          parameter_name: '',
          parameter_value: 1,
          parameter_value_str: '',
          parameter_description: '',

        } ,

      }
    },
    methods: {
      initializeVar(close) {
        this.activeItem = {
          parameter_id: '',
          facility_name: '',
          parameter_name: '',
          parameter_value: '',
          parameter_value_str: '',
          parameter_description: '',

          }
          if(close) {
              this.dialog = false;
          }
      },
      async addRecord (close) {
        await putParameter(
          {
            'parameter_id': this.activeItem.parameter_id,
            'facility_name': this.activeItem.facility_name,
            'parameter_name': this.activeItem.parameter_name,
            'parameter_value': this.activeItem.parameter_value,
            'parameter_value_str': this.activeItem.parameter_value_str,
            'parameter_description': this.activeItem.parameter_description,

          }
        )
          this.$emit('doreload')
          if(close) {
              this.dialog = false;
          }
      }
    },
    name: 'ParameterRecordDialog'
  }
</script>

<style scoped>

</style>
